angular.module("Main").controller("AggregatorClubsController", ["$rootScope", "$scope", "$localStorage", "$state", "$window", "$stateParams", "$location", "$translate", "AggregatorService", "BookingService", "SessionService",
    function ($rootScope, $scope, $localStorage, $state, $window, $stateParams, $location, $translate, AggregatorService, BookingService, SessionService) {
        var vm = this;

        vm.withoutClubsMenuItem = false;
        loadAggregatorenConfig();

        function loadAggregatorenConfig() {
            BookingService.loadTextClubs().then(function (data) {
                vm.aggregatorenConfigtext = data;
            })
        }

        var xlarge = 1700;
        var large = 1500;
        var medium = 1200;
        var small = 900;
        var xs = 450;

        if (!_.isEmpty($stateParams.club)) {
            vm.withoutClubsMenuItem = true;
            $state.go('aggregator_overview', {sid: SessionService.getSessionId(), cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club});
        }

        function checkLimitLength() {
            if ($window.innerWidth >= xlarge) {
                vm.limitLength = 8;
            }
            else if ($window.innerWidth >= large) {
                vm.limitLength = 6;
            }
            else if ($window.innerWidth >= medium) {
                vm.limitLength = 5;
            } else if ($window.innerWidth >= small) {
                vm.limitLength = 4;
            } else if ($window.innerWidth >= xs) {
                vm.limitLength = 3;
            }
        }

        checkLimitLength();
        loadOnlineSalesFarbenConfiguration();

        function getBackgrounds() {
            BookingService.getBackgrounds().then(function (data) {
                vm.backgrounds = data;
            });
        }

        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        function loadConfigs() {
            BookingService.loadLayoutConfiguration().then(function (data) {
                vm.layoutSettings = angular.fromJson(data.Layout);
                getKursbuchungLayouKonfiguration();
            })
        }


        function loadOnlineSalesFarbenConfiguration() {
            BookingService.getOnlineSalesLayout().then(function (data) {
                vm.onlineSalesConfig = data;
                _.toString(vm.onlineSalesConfig.LandingPage);
                getBackgrounds();
                if (data.Background === 0) {
                    vm.checkClubImageDefault = true;
                    vm.checkClubImageCustomize = false;
                } else {
                    vm.checkClubImageDefault = false;
                    vm.checkClubImageCustomize = true;
                }
                if (data.Studio_Images === 0) {
                    vm.checkItemBackgroundDefault = true;
                    vm.checkItemBackgroundCustomize = false;
                } else if (data.Studio_Images === 1) {
                    vm.checkItemBackgroundDefault = false;
                    vm.checkItemBackgroundCustomize = true;
                }

            })
        }

        function loadCurrency() {

            return new Promise((resolve) => {
                BookingService.getCurrency().then(function (data) {
                    vm.currency = data;
                    if (vm.currency.Waehrung === "EUR")
                        vm.currency.Waehrung = "€";
                    resolve(vm);
                })

            })
        }

        //ToDo prüfen was wenn id false/ abfangen => kein Link
        if (!SessionService.getSessionId()) {
            if (_.isUndefined($stateParams.id)) {
                SessionService.setAuthDataId($stateParams.cid, false);
                $state.go('aggregator_overview', {sid: SessionService.getSessionId(), cid: $stateParams.cid, id: false, club: $stateParams.club});
            } else {
                SessionService.setAuthDataId($stateParams.cid, $stateParams.id, $stateParams.club);
                $state.go('aggregator_overview', {sid: SessionService.getSessionId(), cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club});
            }
            start();
        } else
            start();

        async function start() {
            try {
                await loadCurrency();
                init();
            }
            catch {

            }
        }

        async function init() {
            try {
                await loadConfigs();
                await getMandants();
                await checkAggregatoren();
            }
            catch {

            }
        }

        function checkAggregatoren() {
            SessionService.clear('aggregatorData');
            AggregatorService.checkAggregatorenLinkConfig($stateParams.id).then(function (data) {
                if (data.data.LinkIdNotFound === true || data.data.IsInactiv || data.data.Aggregator.length === 0) {
                    vm.linkInactiv = true;
                    vm.isInFuture = data.IsInFuture;
                    vm.isInPast = data.IsInPast;
                    if (data.data.IsInFuture === true) {
                        vm.futureDate = data.data.FutureDate;
                    }
                } else {
                    vm.linkInactiv = false;
                }
            })
        }


        function getMandants() {
            BookingService.getMandantsAll().then(function (data) {
                vm.clubsmandants = data;
                vm.tenantIds = _.map(data, 'MandantNr')
            }).then(function () {
                BookingService.getMandantsImages().then(function (data) {
                    vm.imagesClubs = data;
                    _.forEach(vm.clubsmandants, function (m) {
                        m.Image = _.find(vm.imagesClubs, {'Mandant_Nr': m.MandantNr});
                    });
                })
            }).then(function () {
                BookingService.checkMandantOnline().then(function (data) {
                    vm.mandantsOnline = data;

                    _.forEach(vm.clubsmandants, function (m) {
                        if (_.filter(vm.mandantsOnline, {MandantNr: m.MandantNr}).length > 0) {
                            let foundSortierung = _.filter(vm.mandantsOnline, {
                                MandantNr: m.MandantNr,
                            })[0].Sortierung;
                            m.Sortierung = foundSortierung;
                        }
                    });
                    vm.clubsmandants = _.sortBy(vm.clubsmandants, 'Sortierung');
                    vm.allClubs = [];
                    if (vm.clubsmandants.length < vm.limitLength) {
                        vm.limitLength = vm.clubsmandants.length
                    }
                    vm.chunkedClub = _.chunk(vm.clubsmandants, vm.limitLength);
                    vm.lengthChunkedClubs = (vm.chunkedClub).length;
                    if ($window.innerWidth >= 700) {
                        for (let i = 0; i < vm.limitLength; ++i) {
                            vm.allClubs[i] = vm.clubsmandants[i];
                        }
                    } else {
                        vm.allClubs = vm.clubsmandants;
                    }
                });
            }).then(function () {
                BookingService.getMandantNames().then(function (data) {
                    var mandantsNames = data;
                    _.forEach(vm.clubsmandants, function (m) {
                        if (_.filter(mandantsNames, {'MandantNr': m.MandantNr})) {
                            let foundName = (_.filter(mandantsNames, {'MandantNr': m.MandantNr}))[0].MandantOnlineBezeichnung;
                            if (foundName) {
                                m.MandantOnlineBezeichnung = foundName;
                            }
                            if ($stateParams.club) {
                                if (m.MandantNr === vm.selectedMandantNr) {
                                    vm.selectedMandant = m;
                                    vm.selectedMandant.MandantOnlineBezeichnung = foundName
                                }
                            }
                        }
                    })
                })
                //  }).then(function () {
                // getInfoForStep1();
            })
        }


        vm.chooseClub = function (club) {
            SessionService.setClubData(club);
            $state.go('aggregator_overview', {cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club})

        };

        vm.moveLeft = function () {
            vm.begin--;
            if (vm.begin < 0) {
                vm.begin = 0;
            }
            vm.aggregators = vm.chunckedAggregatoren[vm.begin];
        };

        vm.moveRight = function () {
            vm.begin++;
            if (vm.begin + 1 > vm.chunckedAggregatoren.length) {
                vm.begin = 0
            }
            vm.aggregators = vm.chunckedAggregatoren[vm.begin];
        };

        vm.goToAngebot = function () {
            $state.go('aggregator_overview', {cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club});
            vm.openedMenuBar = false;
        }

        vm.openMenuBar = function () {
            if (vm.openedMenuBar === false) {
                vm.openedMenuBar = true;
            } else {
                vm.openedMenuBar = false;
            }
        };


    }])